
<script setup>
import { Icon } from '@components'
</script>
<template>
    <div class="w-full flex justify-center">
        <Icon name="loading01" size="30px" class="text-[#344054] animate-spin"></Icon>
    </div>
</template>